export default "__VITE_ASSET__nw1rJNpm__"